import Grid from '@/global/components/ui/Grid'
import { FormField, FormFieldSelect } from 'global/components/Form'
import IconeAjuda from 'global/components/IconeAjuda'
import opcoesDiasDSR from '../constants/opcoes-dia-dsr'

export default function CabecalhoTabelaHorarioForm() {
    return (
        <Grid container>
            <Grid item xs={3}>
                <FormField
                    name="codigo"
                    label="Código"
                    placeholder="(gerar automaticamente)"
                    type="number"
                />
            </Grid>
            <Grid item xs={6}>
                <FormField
                    name="nome"
                    label="Nome da tabela"
                    required
                    autoComplete="off"
                />
            </Grid>
            <Grid item xs={3}>
                <FormFieldSelect
                    label="Dia do DSR"
                    name="diaDescontoDSR"
                    options={opcoesDiasDSR()}
                    required
                    endAdornment={
                        <IconeAjuda>
                            <strong>DSR automático</strong>: não aplica o DSR.
                            <br />
                            <strong>DSR variável</strong>: aplica no primeiro
                            dia em que encontra falta.
                            <br />
                            <strong>Dia da semana</strong>: aplica sempre no dia
                            escolhido.
                        </IconeAjuda>
                    }
                />
            </Grid>
        </Grid>
    )
}
